import React from 'react';

import ApiProvider from './context/ApiProvider';
import EventProvider from './context/EventProvider';
import LaunchDarklyProvider from './context/LaunchDarklyProvider';
import PurchaseProvider from './context/PurchaseProvider';

import { LiferayTest } from './components/LiferayTest';

import { Modal } from './containers/Modal';
import { LIFERAY_TEST } from './config';

export default function App() {
  return (
    <LaunchDarklyProvider>
      <ApiProvider>
        <PurchaseProvider>
          <EventProvider>
            <LiferayTest active={LIFERAY_TEST}>
              <Modal />
            </LiferayTest>
          </EventProvider>
        </PurchaseProvider>
      </ApiProvider>
    </LaunchDarklyProvider>
  );
}
